const classes = Object.freeze({
    root: 'll-input ll-accent-input',
});

export {
    classes,
};